'use client';

import { createContext, useContext } from 'react';
import { usePathname } from 'next/navigation';

const HeaderDataContext = createContext({});

export function useHeaderData() {
  return useContext(HeaderDataContext);
}

export const usePathnameWithoutLocal = () => {
  const pathname = usePathname();

  const [, ...segmentsAfterLocale] = pathname.split('/').filter(Boolean);
  const pathnameWithoutLocal = '/' + segmentsAfterLocale.join('/');

  return pathnameWithoutLocal;
};

/**
 * it is used to give active style to the link for mega menu and header links
 */
export function useIsActive({ columns = [], link }) {
  const pathnameWithoutLocal = usePathnameWithoutLocal();

  const isActiveLink = link?.includes(pathnameWithoutLocal) ?? false;
  const containsActiveLink = columns?.some(column => {
    const { children } = column;
    return children.some(({ link }) => link?.includes(pathnameWithoutLocal));
  });

  const isActive = (isActiveLink || containsActiveLink) && pathnameWithoutLocal.length > 1;

  return isActive;
}

export default function HeaderDataProvider({ children, value }) {
  return <HeaderDataContext.Provider value={value}>{children}</HeaderDataContext.Provider>;
}
